import { Component, OnInit, Input, Output, SimpleChanges, EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppComponent } from 'src/app/app.component';
import { OrgInfo, appsForThisOrg } from 'src/app/base/interfaces/org-info';
import { AuthService } from 'src/app/base/services/auth/auth.service';
import { NavService } from 'src/app/base/services/nav/nav.service';
import { WorkflowService } from '../services/workflow/workflow.service';
import { AppidService } from '../services/appid/appid.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-header-base',
  template: ``,
  styles: []
})
export class HeaderBaseComponent implements OnInit {
    @Input() appID: number | null = null;
    @Input() navID: number | null = null;

    @Output() appChangeRequested = new EventEmitter<any>();
    @Output() headerDropdownsReady = new EventEmitter<any>();

    // orginfo are orgs for this app.
    public orginfo: OrgInfo | any;
    public orgLogo: string | null = null;

    public appsForThisOrg: appsForThisOrg[];

    // Actually selectedOrgID and selectedAppID
    selectedOrg: any;
    selectedApp: any;

    tagline: string | null = null;

    constructor(
        public auth: AuthService, 
        public nav: NavService, 
        public app: AppComponent, 
        public workflow: WorkflowService, 
        public appidService: AppidService,
        private route: ActivatedRoute
    ) {}

    ngOnInit(): void {

        if (this.auth.getToken() || localStorage.getItem('V1SID')) {

            // Gets data from back-end to display elements of the header.
            this.nav.getHeaderInfo(
                    this.auth.getOrg(), 
                    this.auth.getToken(), 
                    localStorage.getItem('NavSourcev1'),
                    localStorage.getItem('V1SID'),
                    localStorage.getItem('V1OrgID'),
                    localStorage.getItem('V1UserID')).subscribe(
                (data: OrgInfo) => {
                    let descendantOrgs: any[] = data.descendants ? Object.values(data.descendants) : null;
                    let siblingOrgs: any[] = data.siblings ? Object.values(data.siblings) : null;

                    // The orgs are sorted in a temporary state of Upper Case for comparison purposes only. They will be displayed in their original casing.
                    if (siblingOrgs) {
                        siblingOrgs.sort(function (a, b) {
                            var textA = a.org_name.toUpperCase();
                            var textB = b.org_name.toUpperCase();
                            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                        });
                    }
                    if (descendantOrgs) {
                        descendantOrgs.sort(function (a, b) {
                            var textA = a.org_name.toUpperCase();
                            var textB = b.org_name.toUpperCase();
                            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                        });
                    }

                    if (data.orgLogo) {
                        this.orgLogo = `${environment.urls.core}/files/886/${data.orgLogo}`; // field 886 upload logo.
                    } else {
                        this.orgLogo = null;
                    }
                    
                    // Array for the org dropdown.
                    this.orginfo = {
                        orgName: data.orgName,
                        name: data.name,
                        ancestor: data.ancestor,
                        descendants: descendantOrgs,
                        siblings: siblingOrgs
                    };

                    this.appsForThisOrg = (data.appsForThisOrg).map((orgApps: any) => ({
                        id: orgApps.app_id,
                        name: orgApps.name,
                        tagline: orgApps.tagline
                    }));

                    // Display app tagline under app logo.
                    const foundApp = this.appsForThisOrg.find(app => app.id == this.selectedApp);
                    this.tagline = foundApp ? foundApp.tagline : null;

                    this.headerDropdownsReady.emit(true);
                },
                (error) => {
                    console.warn(error);
                }
            );

            this.selectedOrg = this.auth.getOrg();
        }

        // When user is unauth but an org_id exists in URL, we want to display the Org logo.
        else {
            
            let orgID = this.route.snapshot.queryParams['org_id'];
            if (orgID) {
                this.nav.getOrgLogo(orgID).subscribe((data: any) => {
                    if (data) {
                        this.orgLogo = `${environment.urls.core}/files/886/${data}`;
                    }
                })
            }
            
        }
    }

    // This happens when is a V2->V2 app change. No tested yet.
    ngOnChanges(changes: SimpleChanges): void {
        if (changes['appID'].currentValue) {
            const newAppId = changes['appID'].currentValue;
            this.selectedApp = newAppId;

            // If appsForThisOrg is already loaded, update the tagline
            if (this.appsForThisOrg?.length) {
                const found = this.appsForThisOrg.find(appInfo => String(appInfo.id) === String(newAppId));
                this.tagline = found ? found.tagline : null;
            }
        }
    }

    onOrgChange($event) {

        //get value from dropdown
        let selectedOrgID = $event.value;
        this.selectedOrg = selectedOrgID;

        this.auth.changeOrg(selectedOrgID).subscribe((data: any) => {
            window.location.reload();
        });
    }

	// Currently called by EZS header html file only.
    appChangeClicked($event: any) {
        let selectedAppID = $event.value;
        this.selectedApp = selectedAppID;

        this.appChangeRequested.emit(selectedAppID);
    }
}
